import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import { Container, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Home = () => {
  const aboutUsRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const carouselRef = useRef(null);
  const [showMore, setShowMore] = useState({
    membership: false,
    transferShares: false,
    guarantorship: false,
    crbCollaboration: false,
  });

  const toggleShowMore = (section) => {
    setShowMore((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  useEffect(() => {
    if (location.hash === "#about-us") {
      aboutUsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location]);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const redirectToWhatsApp = (message) => {
    const phone = "254785278786";
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phone}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-100 flex flex-col items-center">
        <main className="flex-grow w-full max-w-7xl mx-auto px-6 py-16">
          {/* Carousel Section */}
          <section ref={carouselRef} className="mt-0">
            <Slider {...sliderSettings}>
              <div className="relative">
                <img
                  src="/assets/img2.jpg"
                  alt="Loan Buy-Off 1"
                  className="w-full h-96 object-cover rounded-lg"
                />
                <div className="absolute inset-0 bg-opacity-60 bg-black flex flex-col justify-center items-center text-center text-white p-6">
                  <h2 className="text-4xl font-extrabold text-gradient bg-clip-text mb-2">
                    Achieve Financial Freedom With Our Loan Buy-Off Program
                  </h2>
                  <p className="text-lg mb-4 font-medium">
                    Our program helps you regain control over your financial future with easy-to-manage loan solutions.
                  </p>
                  <a
                    href="https://wa.me/0785278786"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-red-600 border-2 border-red-600 px-8 py-4 text-lg font-semibold rounded-full shadow-xl transform hover:scale-105 hover:bg-red-600 hover:text-white transition duration-300 ease-in-out"
                  >
                    Start Your Journey Today
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/assets/img3.jpg"
                  alt="Loan Buy-Off 2"
                  className="w-full h-96 object-cover rounded-lg"
                />
                <div className="absolute inset-0 bg-opacity-60 bg-black flex flex-col justify-center items-center text-center text-white p-6">
                  <h2 className="text-4xl font-extrabold text-gradient bg-clip-text mb-2">
                    Say Goodbye to Financial Stress
                  </h2>
                  <p className="text-lg mb-4 font-medium">
                    With our tailored loan buy-off solutions, you can leave financial worries behind and start fresh.
                  </p>
                  <a
                    href="https://wa.me/0785278786"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-red-600 border-2 border-red-600 px-8 py-4 text-lg font-semibold rounded-full shadow-xl transform hover:scale-105 hover:bg-red-600 hover:text-white transition duration-300 ease-in-out"
                  >
                    Get Started Now
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/assets/img4.jpg"
                  alt="Loan Buy-Off 3"
                  className="w-full h-96 object-cover rounded-lg"
                />
                <div className="absolute inset-0 bg-opacity-60 bg-black flex flex-col justify-center items-center text-center text-white p-6">
                  <h2 className="text-4xl font-extrabold text-gradient bg-clip-text mb-2">
                    Your Path to Financial Relief Starts Here
                  </h2>
                  <p className="text-lg mb-4 font-medium">
                    Simplify your financial situation with our clear and effective loan buy-off options.
                  </p>
                  <a
                    href="https://wa.me/0785278786"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white text-red-600 border-2 border-red-600 px-8 py-4 text-lg font-semibold rounded-full shadow-xl transform hover:scale-105 hover:bg-red-600 hover:text-white transition duration-300 ease-in-out"
                  >
                    Take Control Now
                  </a>
                </div>
              </div>
            </Slider>
          </section>

          {/* Cards Section */}
          <section className="mt-5">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: "fas fa-user-plus",
                  message: "I am interested in becoming a member.",
                  title: "Become a Member",
                  description: "Unlock exclusive benefits by joining us today.",
                },
                {
                  icon: "fas fa-hand-holding-usd",
                  message: "I want to learn how to borrow funds with ease and flexibility.",
                  title: "Learn to Borrow",
                  description: "Discover how to borrow funds easily and flexibly.",
                },
                {
                  icon: "fas fa-piggy-bank",
                  message: "I want to start saving and build my financial future.",
                  title: "Start Saving",
                  description: "Build your financial future by starting to save with us.",
                },
                {
                  icon: "fas fa-cogs",
                  message: "I am interested in exploring other financial services.",
                  title: "Explore Services",
                  description: "Check out other financial services tailored for your needs.",
                },
              ].map((card, index) => (
                <div
                  key={index}
                  className="p-6 bg-white rounded-lg shadow-lg text-center cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:bg-teal-50"
                  onClick={() => redirectToWhatsApp(card.message)}
                >
                  <i className={`${card.icon} text-4xl text-teal-700 mb-4`}></i>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">{card.title}</h3>
                  <p className="text-gray-600">{card.description}</p>
                </div>
              ))}
            </div>
          </section>
          <section
  id="about-us-section"
  ref={aboutUsRef}
  className="w-full bg-gradient-to-r from-teal-500 to-teal-800 rounded-lg shadow-xl p-8 relative overflow-hidden mt-12"
>
  <div className="flex flex-col md:flex-row items-center justify-between">
    {/* About Us Content */}
    <div className="md:w-1/2 text-white">
      <h2 className="text-4xl font-semibold mb-4">About Us</h2>
      <p className="text-lg mb-4">
      Metropolitan Hospital Sacco is a regulated, non-withdrawable deposit-taking Sacco established in 1996 by hospital employees with the goal of achieving financial independence. Over the years, the Sacco has grown and evolved into a robust institution, dedicated to empowering its members by providing comprehensive financial solutions and support.
      </p>
      <h3 className="text-2xl font-semibold mb-2">Our Vision</h3>
      <p className="text-lg mb-4">
      To be the leading and trusted financial institution of choice to our members.
      </p>
      <h3 className="text-2xl font-semibold mb-2">Our Mission</h3>
      <p className="text-lg mb-4">
        To promote and foster a savings culture through the provision of innovative, accessible, and affordable financial services for socio-economic growth and prosperity of our members.
      </p>
      <h3 className="text-2xl font-semibold mb-2">Core Values</h3>
      <div className="flex flex-wrap">
  <ul className="text-lg mb-6 list-disc list-inside w-1/2">
    <li>Integrity</li>
    <li>Professionalism</li>
    <li>Customer Focus</li>
  </ul>
  <ul className="text-lg mb-6 list-disc list-inside w-1/2">
    <li>Equality</li>
    <li>Transparency</li>
    <li>Innovation</li>
  </ul>
</div>

      <p className="text-lg italic mb-6">"Building wealth, changing lives."</p>
      
    </div>

    {/* Tilted Image */}
    <div className="md:w-1/2 flex justify-center items-center relative">
      <img
        src="/assets/img14.jpg" 
        alt="About Us"
        className="w-full h-auto rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105"
      />
    </div>
  </div>
</section>

    

        
          {/* Product Management Features Section */}
          <Card className="p-4 shadow-lg">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-4">Loan Products</h2>
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Various Loan Products</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[ 
              { name: "Development loan", img: "/assets/img2.jpg", details: "Maximum loan is 3 times members deposit. Maximum repayment period of 48 months. Interest rate of 1% per month. Processing fee of 1.5%. Guarantors or collateral can be used as security." },
              { name: "Investment loan", img: "/assets/img6.jpg", details: "Maximum loan is 3 times member’s deposit. Maximum repayment period of 48 months. Interest rate is 1.2% per month. Processing fee of 1.5%." },
              { name: "Asset Finance", img: "/assets/img3.jpg", details: "Maximum loan is 80% of the asset value. Maximum repayment period is 60 months. Interest rate is 1.2%. Security of the loan is the asset." },
              { name: "School fees loan", img: "/assets/img8.jpg", details: "Maximum amount is 200,000. Interest rate of 1% per month. Processing fee of 1.5%. Maximum repayment period of 24 months." },
              { name: "Emergency loan", img: "/assets/img9.jpg", details: "Maximum amount is 50,000. Maximum repayment period is 12 months. Loan interest is 1% per month. Processing fee of 1.5%." },
              { name: "Instant loan", img: "/assets/img10.jpg", details: "Maximum loan is 30,000. Maximum repayment period is 4 months. Loan interest of 10%. Application available online." },
            ].map((loan, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                <img src={loan.img} alt={loan.name} className="w-full mb-4" />
                <h3 className="text-xl font-semibold text-gray-800">{loan.name}</h3>
                <p className="text-gray-600">{loan.details}</p>
              </div>
            ))}
          </div>
        </Card>
        
        <Card className="p-4 mt-5 shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 text-center mb-4">Savings Products</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {[ 
              { name: "Non-withdrawable deposit", img: "/assets/img11.jpg", details: "It is refundable upon exit from the sacco. The minimum deposit is Ksh 2,000 and loans are offered at *3 multiplier." },
              { name: "Target deposit", img: "/assets/img12.jpg", details: "A voluntary withdrawable savings scheme for members which earns them an interest of 8% per annum compounded monthly." }
            ].map((saving, index) => (
              <div key={index} className="p-6 bg-white rounded-lg shadow-lg text-center">
                <img src={saving.img} alt={saving.name} className="w-full mb-4" />
                <h3 className="text-xl font-semibold text-gray-800">{saving.name}</h3>
                <p className="text-gray-600">{saving.details}</p>
              </div>
            ))}
          </div>
        </Card>
<div className="mt-16 p-8 bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-lg shadow-xl text-center max-w-4xl mx-auto">
    <h3 className="text-2xl font-bold mb-4">LOAN INSURANCE</h3>
    <p className="text-lg">
      All loans are insured against permanent disability and death of a member. Loans must be up to date.
      The original death certificate and burial permit must be accompanied during the claim process.
      Members are requested to update their next of kin regularly.
    </p>
  </div>



        </main>
      </div>
      <div className="flex flex-col items-center">
                  <div className="font-bold text-3xl">Find Us</div>
                  <div className="my-map">
          <iframe
            title="Metropolitan Hospital Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15955.571479371347!2d36.8659665!3d-1.2874862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f1314c2f5e031%3A0x3906383134dd4dee!2sMetropolitan%20Hospital%20Sacco%20Limited!5e0!3m2!1sen!2ske!4v1709466367812!5m2!1sen!2ske"
            width="1200"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            gestureHandling="none"
            frameBorder="0"
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
                </div>
      <Footer />
    </>
  );
};

export default Home;

